import { ExpenseCategoriesPage } from "./ExpenseCategoriesPage";
import { ExpenseCreate, ExpenseEdit } from "./ExpenseForm";
import { ExpenseList } from "./ExpenseList";
import { ExpenseShow } from "./ExpenseShow";
import type { Expense } from "./expenseTypes";

/**
 * Almikia Epic EG (TASK-044): the `expenses` resource ("Gastos"). Create, edit
 * and show, but NO delete: an expense is cancelled with a reason, never
 * deleted. Access is gated by `canAccess` (direccion, lead_manager,
 * administracion, contabilidad).
 */
export default {
  list: ExpenseList,
  show: ExpenseShow,
  create: ExpenseCreate,
  edit: ExpenseEdit,
  recordRepresentation: (record: Expense) => record.concept,
};

/**
 * The `expense_categories` resource ("Categorías de gastos"): one inline admin
 * screen as its list; read-only unless the role may edit (direccion).
 */
export const expenseCategories = {
  list: ExpenseCategoriesPage,
};

// TASK-045: custom pages of the Gastos area (routes registered in `CRM.tsx`).
export { ExpenseMonthlyTotals } from "./ExpenseMonthlyTotals";
export { ExpenseReimbursements } from "./ExpenseReimbursements";
